const env_var = process.env;
export const client_id = env_var.REACT_APP_CLIENTID;
export const pool_id = env_var.REACT_APP_POOLID;
export const identityPoolId = env_var.REACT_APP_IDENTITY_POOL;
export const region = env_var.REACT_APP_REGION;
export const cognito_domain = env_var.REACT_APP_COGNITO_DOMAIN;
export const cognito_saml_provider = env_var.REACT_APP_COGNITO_SAML_PROVIDER;
export const cognito_saml_redirect_url =
  env_var.REACT_APP_COGNITO_SAML_REDIRECT_URL;
